/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateClaimAccountRequest } from './CreateClaimAccountRequest';
import type { CreateClaimImageRequest } from './CreateClaimImageRequest';
import type { CreateClaimItemRequest } from './CreateClaimItemRequest';
export type EditClaimDetailRequest = {
    shopId: string;
    customerFirstName: string;
    customerLastName: string;
    customerCitizenId?: string;
    customerPassportNo?: string;
    customerPhoneNumber: string;
    customerFacebookUrl?: string;
    customerLineId?: string;
    customerNote?: string;
    items: Array<CreateClaimItemRequest>;
    brand: string;
    version: string;
    imei?: string;
    serialNumber?: string;
    battery?: number;
    defect?: string;
    lockType: EditClaimDetailRequest.lockType;
    lockPassword?: string;
    lockImage?: CreateClaimImageRequest;
    accounts?: Array<CreateClaimAccountRequest>;
    productNote?: string;
};
export namespace EditClaimDetailRequest {
    export enum lockType {
        NONE = 'NONE',
        PIN = 'PIN',
        PASSWORD = 'PASSWORD',
        PATTERN = 'PATTERN',
    }
}

